export const formatTakaNo = (
  series: string | null | undefined,
  takaNo: number | string | null | undefined
): string => {
  if (takaNo === null || takaNo === undefined || takaNo === '') return '';
  if (!series) return String(takaNo);
  return `${series}-${takaNo}`;
};

export const parseTakaSearch = (
  input: string
): { series: string | null; takaNo: number } | null => {
  if (!input) return null;
  const s = String(input).trim();
  if (s === '') return null;
  const composed = s.match(/^([A-Za-z0-9]{1,5})-(\d+)$/);
  if (composed) {
    return { series: composed[1].toUpperCase(), takaNo: parseInt(composed[2], 10) };
  }
  if (/^\d+$/.test(s)) {
    return { series: null, takaNo: parseInt(s, 10) };
  }
  return null;
};

export const seriesLabel = (series: string | null | undefined): string => {
  return series ? series : 'Default';
};
